/**
 *  All api related to authentication
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function createSmsToken({ phone }) {
  const payload = {
    data: {
      smsToken: {
        phone
      }
    }
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'createSmsToken',
    () => source.cancel('createSmsToken: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `sms_tokens`,
      method: 'post',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      data
    }))
}

export function createWhatsappToken({ phone }) {
  const payload = {
    data: {
      smsToken: {
        phone
      }
    }
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'createWhatsappToken',
    () => source.cancel('createWhatsappToken: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `sms_tokens/whatsapp_token`,
      method: 'post',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      whatsappToken: _.get(data, 'whatsappToken'),
    }))
}

export function createEmailToken({ email }) {
  const payload = {
    data: {
      emailToken: {
        email
      }
    }
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'createEmailToken',
    () => source.cancel('createEmailToken: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `email_tokens`,
      method: 'post',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      data
    }))
}

export function createSession(data) {
  const payload = {
    data
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'createSession',
    () => source.cancel('createSession: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `sessions`,
      method: 'post',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      session: data.session
    }))
}

export function createRegistration(data) {
  const payload = {
    data
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'createRegistration',
    () => source.cancel('createRegistration: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `registrations`,
      method: 'post',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      registration: data.registration
    }))
}

export function deleteSession() {
  const source = CancelToken.source()
  cancelRequest.add(
    'deleteSession',
    () => source.cancel('deleteSession: Operation cancelled by user')
  )
  const payload = {
    data: {
      session: {}
    }
  }
  return OmnitechApi
    .request({
      endpoint: `sessions`,
      method: 'delete',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(() => ({
    }))
}

export function deleteAuthenticationsByProvider(provider) {
  const payload = {
    data: {
      authentication: { }
    }
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'deleteAuthenticationsByProvider',
    () => source.cancel('deleteAuthenticationsByProvider: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `authentications/by_provider/${provider}`,
      method: 'delete',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      omniAuthOtp: data.omniAuthOtp
    }))
}
